<template>
    <div ref="shareAccountModal" class="modal fade" :id="dialogId" role="dialog" :aria-labelledby="dialogId"
         aria-hidden="true">
        <div class="modal-dialog modal-dialog-popout" role="document">
            <div class="modal-content">
                <div class="block block-themed block-transparent mb-0">
                    <div class="block-header bg-primary-dark">
                        <h3 class="block-title">{{title}}</h3>
                        <div class="block-options">
                            <button type="button" class="btn-block-option" data-dismiss="modal" aria-label="Close">
                                <i class="fa fa-fw fa-times"/>
                            </button>
                        </div>
                    </div>
                    <div class="block-content">
                        <!--                        <div class="push">-->
                        <!--                            Sharing an account -->
                        <!--                        </div>-->
                        <div class="form-group">
                            <label>User</label>
                            <user-dropdown :invited-user="sharedAccount"/>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button :disabled="loading" type="button" class="btn btn-outline-success" @click="shareAccount">
                        <i class="fa fa-share-alt mr-2"/>
                        Share
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import UserDropdown from "../user/user-dropdown";
    import {APP_CONFIG} from "../../config";
    import {mapGetters} from 'vuex'

    export default {
        props: {
            dialogId: {
                type: String
            },
            title: {
                type: String
            },
            account: {
                type: String
            }
        },
        name: "ShareBillingAccountDialog",
        components: {
            UserDropdown,
        },
        data() {
            return {
                sharedAccount: {
                    userId: '',
                    account: '',
                }
            }
        },
        mounted() {
            $(this.$refs.shareAccountModal).on('hidden.bs.modal', () => {
                this.closeDialog();
            });
        },
        computed: {
            ...mapGetters({loading: 'getLoadingStatus'})
        },
        methods: {
            closeDialog() {
                this.$store.commit('setUsers', []);
                this.sharedAccount = {
                    userId: '',
                    account: '',
                };
            },
            shareAccount() {
                this.$store.commit('setLoadingStatus', true);
                this.sharedAccount.account = this.account;
                axios.post(APP_CONFIG.URL + `billing/accounts/${this.account}/share`, this.sharedAccount).then(res => {
                    $(`#${this.dialogId}`).modal('hide')
                }).finally(() => {
                    this.$store.commit('setLoadingStatus', false)
                });
            }
        }
    }
</script>

<style scoped>

</style>
